export const REQUIRED_BLOCKS_NUMBER = 3;

export const SUBTITLE_LAYOUT = 'sub_title';

export const SUBTITLE_RUSSIAN_KEY = 'russian_sub_title';

export const SUBTITLE_ENGLISH_KEY = 'english_sub_title';
